import { paymentGatewayApi } from "@api/instances";
import { ApiResponse } from "@api/apiRequest";
import rollbar, { LogMetadata } from "@utils/rollbar";

const setDefaultPaymentMethod = async (
  paymentMethodId: string,
): Promise<ApiResponse<null>> => {
  try {
    await paymentGatewayApi.put(
      "/v1/billing/payment-methods/default",
      { paymentMethodId },
      { requireAuth: true },
    );
    return { data: null, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/billing/payment-methods/default", method: "PUT", paymentMethodId };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Failed to set default payment method" };
  }
};

export default setDefaultPaymentMethod;
